require('../../../modules/es.string.includes');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').includes;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/string/virtual/includes.js
// module id = 564
// module chunks = 0 1